import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowLeftRight, FileText, ShoppingCart, X } from "lucide-react";

/**
 * Bước trung gian: chọn loại HĐ trước khi mở form ghi nhận.
 */
const InvoiceTypePickerModal = ({ isOpen, onClose, onSelect }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-[140] flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm"
          onClick={onClose}
        />
        <motion.div
          initial={{ opacity: 0, scale: 0.96, y: 12 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.96, y: 12 }}
          className="relative w-full max-w-md overflow-hidden rounded-3xl border border-white bg-white shadow-2xl"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-start justify-between gap-3 border-b border-slate-100 bg-gradient-to-r from-red-50 via-white to-white px-6 py-5">
            <div className="flex items-center gap-3">
              <span className="rounded-2xl bg-red-600 p-2.5 text-white shadow-lg shadow-red-200">
                <ArrowLeftRight size={18} />
              </span>
              <div>
                <h2 className="text-lg font-black tracking-tight text-slate-800">
                  Chọn loại hóa đơn
                </h2>
                <p className="mt-0.5 text-sm text-slate-500">
                  Chọn mua hoặc bán trước khi ghi nhận.
                </p>
              </div>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="rounded-xl p-2 text-slate-400 hover:bg-red-50 hover:text-red-600"
            >
              <X size={18} />
            </button>
          </div>

          <div className="grid grid-cols-1 gap-3 p-6 sm:grid-cols-2">
            <button
              type="button"
              onClick={() => onSelect?.("purchase")}
              className="group flex flex-col items-start gap-3 rounded-2xl border border-blue-100 bg-blue-50/60 p-4 text-left transition-all hover:border-blue-300 hover:bg-blue-50 hover:shadow-md"
            >
              <span className="rounded-xl bg-blue-600 p-2.5 text-white shadow-sm shadow-blue-200">
                <ShoppingCart size={18} />
              </span>
              <div>
                <p className="text-sm font-black text-slate-800 group-hover:text-blue-800">
                  Hóa đơn mua
                </p>
                <p className="mt-1 text-[11px] font-medium text-slate-500">
                  Ghi nhận HĐ từ nhà cung cấp
                </p>
              </div>
            </button>

            <button
              type="button"
              onClick={() => onSelect?.("sale")}
              className="group flex flex-col items-start gap-3 rounded-2xl border border-red-100 bg-red-50/60 p-4 text-left transition-all hover:border-red-300 hover:bg-red-50 hover:shadow-md"
            >
              <span className="rounded-xl bg-red-600 p-2.5 text-white shadow-sm shadow-red-200">
                <FileText size={18} />
              </span>
              <div>
                <p className="text-sm font-black text-slate-800 group-hover:text-red-800">
                  Hóa đơn bán
                </p>
                <p className="mt-1 text-[11px] font-medium text-slate-500">
                  Ghi nhận HĐ bán đã xuất bên ngoài
                </p>
              </div>
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default InvoiceTypePickerModal;
